var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBadge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 438,
    viewBox: "0 0 350 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_48_5139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0H310C332.091 0 350 17.9086 350 40V219V277.766C350 305.229 336.252 330.868 313.377 346.066L197.135 423.294C183.723 432.204 166.277 432.204 152.865 423.294L36.6231 346.066C13.7482 330.868 0 305.229 0 277.766V219V40Z",
    fill: "url(#paint0_linear_48_5139)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_5139",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 350,
    height: 430
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40C0 17.9086 17.9086 0 40 0H310C332.091 0 350 17.9086 350 40V219V277.766C350 305.229 336.252 330.868 313.377 346.066L197.135 423.294C183.723 432.204 166.277 432.204 152.865 423.294L36.6231 346.066C13.7482 330.868 0 305.229 0 277.766V219V40Z",
    fill: "url(#paint1_linear_48_5139)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_5139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431 37L-37 304L-53 -44L279 -77L431 37Z",
    fill: "url(#paint2_linear_48_5139)",
    fillOpacity: 0.2,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_48_5139",
    x: 0,
    y: 0,
    width: 350,
    height: 433.977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_48_5139"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_innerShadow_48_5139",
    result: "effect2_innerShadow_48_5139"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_5139",
    x1: 175,
    y1: 0,
    x2: 175,
    y2: 438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677885,
    stopColor: "#203F91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14236F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_48_5139",
    x1: 175,
    y1: 0,
    x2: 175,
    y2: 438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1E7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677885,
    stopColor: "#1D3880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141E53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_48_5139",
    x1: 189,
    y1: -77,
    x2: 189,
    y2: 304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF7F7",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/badge.6f0b0b5a08efb48f92ecc63075c908c3.svg";